import { Warning } from '@mui/icons-material'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  Typography,
} from '@mui/material'
import React from 'react'

interface RetriggerNotificationsDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  appointmentId?: string
  customerName?: string
}

export const RetriggerNotificationsDialog: React.FC<RetriggerNotificationsDialogProps> = ({
  open,
  onClose,
  onConfirm,
  appointmentId,
  customerName,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <Warning color="warning" />
          <Typography variant="h6">Retrigger Scout Notifications</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to retrigger scout notifications for this appointment?
        </DialogContentText>
        <Box mt={2}>
          <Typography variant="body2" color="text.secondary">
            <strong>Customer:</strong> {customerName || 'Unknown'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <strong>Appointment ID:</strong> {appointmentId || 'Unknown'}
          </Typography>
        </Box>
        <Box mt={2} p={2} bgcolor="warning.light" borderRadius={1}>
          <Typography variant="body2" color="warning.dark">
            <strong>Warning:</strong> This will send new notification emails to all assigned scouts.
            Use this feature carefully to avoid spamming scouts with duplicate notifications.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button
          onClick={() => {
            onConfirm()
            onClose()
          }}
          color="warning"
          variant="contained"
        >
          Retrigger Notifications
        </Button>
      </DialogActions>
    </Dialog>
  )
}
